// src/components/Login.js
import React, { useState } from "react";
import { auth } from "../firebase";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const provider = new GoogleAuthProvider();

  const signInWithGoogle = () => {
    signInWithPopup(auth, provider).catch((error) => {
      alert("Google Sign-In failed.");
      console.error(error);
    });
  };

  const handleEmailLogin = () => {
    signInWithEmailAndPassword(auth, email, password).catch((error) => {
      alert("Email login failed. Check credentials.");
      console.error(error);
    });
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="/images/LNB.png.jpeg" alt="L&B Logo" className="logo" />
        <h2>Sign In to GenAI KrishiTech</h2>
        <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
        <input type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
        <button onClick={handleEmailLogin}>🔑 Login</button>
        <p>or</p>
        <button onClick={signInWithGoogle}>🔒 Sign in with Google</button>
      </div>

      <div className="info-wrapper">
        <div className="info-card">
          <img src="/images/genaifarm.png.jpeg" alt="GenAI" className="card-img" />
          <h3>🌿 What is GenAI?</h3>
          <p>AI in agriculture helps in smarter crop management and better decisions.</p>
        </div>

        <div className="info-card">
         <img src="/images/aicrop.png.jpeg" alt="AI Crop" className="card-img" />
          <h3>🤖 AI Farming</h3>
          <p>AI enables precision farming using drones and sensors.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
